import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ProviderContactInfoModel from "../../models/provider-contact-info";

export default class ProviderContactInfoRepository extends BaseRepository {
  static modelClass = ProviderContactInfoModel;
  modelName = "provider-contact-info";

  async bulkCreate(data) {
    return await super.createBulk(data, {
      urlPath: "provider-contact-info/bulk_create",
    });
  }

  async bulkUpdate(data) {
    return await super.createBulk(data, {
      urlPath: "provider-contact-info/bulk_update",
    });
  }

  async bulkDelete(data) {
    return await super.createBulk(data, {
      urlPath: "provider-contact-info/bulk_delete",
    });
  }
}
